// Fallback newly-extracted keys to the key itself (i18next-cli passes the key as the first arg).
const defaultValue = (key) => key ?? '';
/**
 * Shared i18next-cli extract config — see UICore/README.md ("Internationalization").
 * Kept a plain object on purpose: this module is re-exported by the runtime i18n barrel,
 * so importing `i18next-cli` here would pull the CLI (and @swc/core) into the app bundle.
 */
export const baseI18nConfig = {
    locales: ['bg', 'en'],
    extract: {
        defaultNS: 'translation',
        defaultValue,
        functions: ['t', 'translate'],
        // `errors.json` is manually curated; exclude it so extraction won't prune it to `{}`.
        ignoreNamespaces: ['errors'],
        indentation: 4,
        input: ['src/**/*.{ts,tsx}'],
        keySeparator: false,
        nsSeparator: false,
        output: 'src/translations/{{language}}/{{namespace}}.json',
        sort: true,
    },
};
